import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#17579E",
    },
    secondary: {
      main: "#fff",
    },
  },
  typography: {
    fontFamily: ["Poppins", "sans-serif"].join(","),
    fontSize: 16,
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  custom: {
    dark: {
      mainColor: "#17579e",
      mainColorHover: "#123f72",
      secColor: "#fff",
      textColor: "##fff",
      f17: "1.19rem",
      f16: "1rem",
      f15: "0.94rem",
      f14: "0.9rem",
    },
    light: {
      mainColor: "#17579e",
      mainColorHover: "#123f72",
      secColor: "#fff",
      textColor: "#00000099",
      f17: "1.19rem",
      f16: "1rem",
      f15: "0.94rem",
      f14: "0.9rem",
    },
  } as any,
});

export default theme;
